
import moment from 'moment';
import { createContainer, InjectionMode, Lifetime, asValue, asClass, asFunction } from 'awilix';
import { syncHistoryWithStore } from 'react-router-redux';
import { createBrowserHistory } from 'history';

import config from './config';
import configureStore from '../redux/store/configureStore';

import * as Actions from '../redux/reducers/actions';
import { transform as personTransform } from './transformers/person.transformer';
import { transform as reportTransform } from './transformers/report.transformer';
import { transform as unitTransform } from './transformers/unit.transformer';
import { transform as jobTransform } from './transformers/job.transformer';
import { transform as kpiTypeTransform } from './transformers/kpiType.transformer';
import { transform as attachmentTransform } from './transformers/attachment.transformer';
import { transform as evaluationTransform } from './transformers/evaluation.transformer';
import { transform as executionLevelTransform } from './transformers/execution-level.transformer';
import { transform as traningEventTypeTransform } from './transformers/traning-event-type.transformer';
import { transform as traningCategoriesTransform } from './transformers/traning-categories.transformer';
import { transform as userTransform } from './transformers/user.transformer';

import enLocal from './locals/english.locale.json';
import heLocal from './locals/hebrew.locale.json';
import arLocal from './locals/arabic.locale.json';
import { fetchSystemSettings } from '../redux/actions/system-settings.actions';
export const container = createContainer({
	injectionMode: InjectionMode.PROXY
});

export const configureContainer = (storage) => {
	const { store, persistor } = configureStore(window.INITIAL_STATE, storage);
	const history = syncHistoryWithStore(createBrowserHistory(), store);

	store.subscribe(() => {
		const storeLocale = store.getState().locale.language.short;
		if(moment.locale() !== storeLocale) {
			moment.locale(storeLocale);
		}
	});

	store.dispatch(fetchSystemSettings())

	container.register({
		config: asValue(config),
		history: asValue(history),
		store: asValue(store),
		persistor: asValue(persistor),
		actions: asValue(Actions),
		transformers: asValue({
			person: personTransform,
			report: reportTransform,
			unit: unitTransform,
			job: jobTransform,
			kpiType: kpiTypeTransform,
			attachment: attachmentTransform,
			evaluation: evaluationTransform,
			execution_level: executionLevelTransform,
			traning_event_type: traningEventTypeTransform,
			traning_categories: traningCategoriesTransform,
			user: userTransform,
		}),
		locals: asValue({
			'en-gb': enLocal,
			 he: heLocal,
			'ar-ar':arLocal,
		}),
	});

	return container;
}

export default {
	configureContainer,
	container,
};